import React from "react";
import { Button, Row, Col, Input, Space, Checkbox } from "antd";
import {CharLimit as charLimit} from "../../../constant/constants";
import CustomInputNumber from "../../CustomInputNumber";

function CategoryVariationRows({
  rows,
  setRows,
  // originalRows,
  disabled,
  // hasMultipleOptions,
  // handleHasMultipleOptions,
}) {
  const addRow = () => {
    const newRow = {
      id: Date.now().toString(), // Ensure id is always a string and unique
      name: "",
      weight: "",
      isOptionRemoved: "No",
    };
    setRows([...rows, newRow]);
  };

  const removeRow = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleInputChange = (id, field, value) => {
    if (field === "name") {
      value = value.slice(0, charLimit.Name);
    }
    setRows(
      rows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const handleWeightChange = (nameValObj) => {
    const [id, field] = nameValObj.name.split("_");
    handleInputChange(id, field, nameValObj.value);
  }

  if (disabled) {
    return null; // Return null to hide the whole component when disabled
  }

  return (
    <div className="flex flex-col mb-[20px]">
      <div className="font-bold mb-3 w-full flex items-center justify-between">
        <p>Add Variants</p>
        {/* <Checkbox
          checked={hasMultipleOptions}
          onChange={(e) => handleHasMultipleOptions(e.target.checked)}
          disabled={disabled}
        >
          Multiple Options
        </Checkbox> */}
      </div>

      <div>
        {rows.map((row, index) => {
          if (row.name === "System Default") return;
          return (
            <div key={index}>
            <Row
              key={row.id}
              gutter={[16, 16]}
              align="middle"
            >
              <Col span={12}>
                <Input
                  placeholder="Variants"
                  value={row.name}
                  onChange={(e) =>
                    handleInputChange(row.id, "name", e.target.value)
                  }
                />
              </Col>

              <Col span={5}>
                <CustomInputNumber 
                  name={`${row.id}_weight`}
                  placeholder="weight"
                  value={row.weight}
                  setValue={handleWeightChange}
                  isDecimalAllowed={true}
                  shouldSetValueSetObj={true}
                />
              </Col>
              <Col span={6}>
                <Space>
                  <Button
                    onClick={() => removeRow(row.id)}
                    style={{ border: "none", padding: 0 }}
                    className="w-8 h-8 mt-[8px]"
                  >
                    <img
                      src="/images/icons/remove.svg"
                      alt="Remove"
                      className="w-8 h-8"
                    />
                  </Button>
                </Space>
              </Col>
            </Row>
            
                <div className="text-[12px] text-gray-600 italic mb-5">
                  Char limit {charLimit.Name}, current: {row.name.length}
                </div>
            </div>
            
          );
        })}
        <Button
          shape="circle"
          onClick={addRow}
          style={{ border: "none", padding: 0 }}
        >
          <img
            src="/images/icons/add-icon-new.svg"
            alt="Add"
            className="w-8 h-8"
          />
        </Button>
      </div>
    </div>
  );
}

export default CategoryVariationRows;
